import gsap from 'gsap'

const BG = '#B1122A'
const CELL_SIZE = 150

export default class HomeIntro {
	constructor() {
		this.root = document.querySelector('[data-home-intro]')
		if (!this.root) return

		this.blue = this.root.querySelector('[data-home-intro-blue]')
		this.logo = this.root.querySelector('[data-home-intro-logo]')
		this.redGroup = this.root.querySelector('[data-logo-red]')
		this.redDark = this.root.querySelector('[data-logo-red-dark]')
		this.redBright = this.root.querySelector('[data-logo-red-bright]')
		this.primeGroup = this.root.querySelector('[data-logo-prime]')
		this.groupGroup = this.root.querySelector('[data-logo-group]')
		this.dissolve = this.root.querySelector('[data-home-intro-dissolve]')
		this.ghost = this.root.querySelector('[data-home-intro-ghost]')
		this.grid = this.root.querySelector('[data-home-intro-grid]')

		document.documentElement.style.overflow = 'hidden'

		this.#buildGhost()
		this.#buildGrid()
		this.#buildTimeline()
	}

	#buildGhost() {
		const clone = this.logo.cloneNode(true)
		clone.removeAttribute('data-home-intro-logo')
		clone.style.opacity = '1'
		this.ghost.appendChild(clone)
	}

	#buildGrid() {
		const w = window.innerWidth
		const h = window.innerHeight
		const cols = Math.max(1, Math.ceil(w / CELL_SIZE))
		const rows = Math.max(1, Math.ceil(h / CELL_SIZE))
		const cellW = w / cols
		const cellH = h / rows
		const maxDist = Math.max(1, cols - 1 + (rows - 1))

		this.triangles = []
		const frag = document.createDocumentFragment()

		for (let r = 0; r < rows; r++) {
			for (let c = 0; c < cols; c++) {
				const dist = cols - 1 - c + (rows - 1 - r)
				const delay = (dist / maxDist) * 0.7
				const x = c * cellW
				const y = r * cellH

				const bl = this.#makeTriangle(x, y, cellW, cellH, '0% 100%', 'polygon(0% 0%, 0% 100%, 100% 100%)')
				const tr = this.#makeTriangle(x, y, cellW, cellH, '100% 0%', 'polygon(0% 0%, 100% 0%, 100% 100%)')

				bl.__delay = delay
				tr.__delay = delay
				this.triangles.push(bl, tr)
				frag.appendChild(bl)
				frag.appendChild(tr)
			}
		}

		this.grid.appendChild(frag)
	}

	#makeTriangle(x, y, w, h, origin, clip) {
		const wrap = document.createElement('div')
		wrap.style.cssText = `position:absolute;left:${x}px;top:${y}px;width:${w + 0.5}px;height:${h + 0.5}px;transform-origin:${origin};overflow:hidden;`

		const inner = document.createElement('div')
		inner.style.cssText = `width:100%;height:100%;background-color:${BG};clip-path:${clip};`
		wrap.appendChild(inner)
		return wrap
	}

	#buildTimeline() {
		gsap.set(this.logo, { opacity: 0 })
		gsap.set(this.redGroup, { opacity: 0 })
		gsap.set(this.redDark, { opacity: 0 })
		gsap.set(this.redBright, { opacity: 0 })
		gsap.set(this.primeGroup, { opacity: 0, y: 16 })
		gsap.set(this.groupGroup, { opacity: 0, y: 16 })
		gsap.set(this.dissolve, { display: 'none' })

		const tl = gsap.timeline({
			onComplete: () => this.#finish(),
		})

		// Phase 1: blue hold
		tl.to({}, { duration: 0.25 })

		// Phase 2: logo build
		tl.to(this.logo, { opacity: 1, duration: 0.2 })
			.to([this.redGroup, this.redDark, this.redBright], { opacity: 1, duration: 0.35, ease: 'power2.out' }, '<=')
			.to(this.primeGroup, { opacity: 1, y: 0, duration: 0.35, ease: 'power3.out' }, '<=50%')
			.to(this.groupGroup, { opacity: 1, y: 0, duration: 0.35, ease: 'power3.out' }, '<=50%')

		// Phase 2.5: delay, then swap blue for dissolve
		tl.to({}, { duration: 0.2 })
		tl.call(() => {
			this.blue.style.display = 'none'
			this.dissolve.style.display = 'block'
		})

		// Phase 3: dissolve
		tl.to(this.ghost, { opacity: 0, duration: 0.33, ease: 'power2.in' }, '<')
		tl.to(
			this.triangles,
			{
				scale: 0,
				duration: 0.65,
				ease: 'power4.out',
				delay: (i, el) => el.__delay,
			},
			'<'
		)
	}

	#finish() {
		document.documentElement.style.overflow = ''
		this.root.remove()
	}
}
